import React from 'react';
import SkeletonBlock from './SkeletonBlock';
import { ListRowSkeletonStack } from './ListRowSkeleton';

export default function PortalShellSkeleton({ label = 'Loading portal' }) {
  return (
    <div className="sk-host sk-portal-shell" role="status" aria-busy="true" aria-label={label}>
      <nav className="sk-portal-shell__nav">
        <SkeletonBlock width="70%" height={16} />
        <SkeletonBlock width="82%" height={14} />
        <SkeletonBlock width="64%" height={14} />
        <SkeletonBlock width="76%" height={14} />
      </nav>
      <div className="sk-portal-shell__content">
        <SkeletonBlock width="36%" height={22} />
        <ListRowSkeletonStack rows={4} variant="upcoming" label={label} />
      </div>
    </div>
  );
}

export function CardStackSkeleton({ cards = 4, label = 'Loading' }) {
  return (
    <div className="sk-host sk-card-stack" role="status" aria-busy="true" aria-label={label}>
      {Array.from({ length: cards }, (_, index) => (
        <div className="sk-card-tile" key={index}>
          <div className="sk-list-row__top">
            <SkeletonBlock width="38%" height={14} />
            <SkeletonBlock variant="pill" width={72} height={20} />
          </div>
          <SkeletonBlock width="54%" height={12} />
          <SkeletonBlock width="28%" height={10} />
        </div>
      ))}
    </div>
  );
}
